import { createContext, FC, ReactNode, useCallback, useMemo } from 'react';

import { useRequiredContext } from 'src/hooks/useRequiredContext';
import { searchBookings } from 'src/store/search/services';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface SearchContextValue {
  loadMore: (startIndex: number, stopIndex: number) => Promise<void>;
}

export const SearchContext = createContext<SearchContextValue | undefined>(
  undefined,
);
SearchContext.displayName = 'SearchContext';

interface SearchProviderProps {
  children?: ReactNode;
}

export const SearchProvider: FC<SearchProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch();

  const loadMore = useCallback(async () => {
    await dispatch(searchBookings(false));
  }, [dispatch]);

  const contextValue = useMemo((): SearchContextValue => {
    return {
      loadMore,
    };
  }, [loadMore]);

  return (
    <SearchContext.Provider value={contextValue}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = (): SearchContextValue =>
  useRequiredContext(SearchContext);
